import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { deletebannerDispatch } from 'reducers/HomeReducer';

export default function MarkupTable() {
	const { bannerInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const { agent, partnermar } = useSelector((state) => state.home);
	let newA = [];
	let newB = [];
	if (agent && partnermar) {
		agent &&
			agent?.result?.map((d) => {
				partnermar &&
					partnermar?.result?.map((l) => {
						if (l.agent_id === d.id) {
							newA.push({
								...l,
								agent: d,
							});
						}
					});
			});
	}
	console.log('first', newA);
	const columns = [
		{ field: 'id', headerName: 'ID', width: 90 },
		{
			field: 'agent',
			headerName: 'Agent Name',
			width: 150,
			height: 300,
			editable: true,
			renderCell: (params) => (
				<p>{`${params.value.first_name} ${params.value.last_name}`}</p>
			),
		},
		{
			field: 'agent',
			headerName: 'Agency Name',
			width: 150,
			height: 300,
			editable: true,
			renderCell: (params) => <p>{`${params.value.agency_name}`}</p>,
		},
		{
			field: 'value',
			headerName: 'Value',
			width: 200,
		},
		{
			field: 'type',
			headerName: 'Type',
			width: 200,
		},
		{
			field: 'action',
			headerName: 'Action',
			width: 200,
			editable: true,
			renderCell: (cellValues) => {
				return (
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10 }}
							onClick={(event) => {
								handleClickDelete(event, cellValues);
							}}>
							Modify
						</Button>
					</Box>
				);
			},
		},
	];
	const handleClick = (event, cellValues) => {
		console.log('id', cellValues.id);
	};
	const handleClickDelete = (event, cellValues) => {
		console.log('id', cellValues.id);
		dispatch(deletebannerDispatch(cellValues.id));
	};
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			{newA && newA?.length > 0 ? (
				<DataGrid
					rows={newA}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 5,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
